module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraLightItalic.cf9a7578.ttf";